import { useTranslation } from '../../../api/useTranslation';

// Translate content consisting of multiple translation keys
export const useTranslateMessageContent = (content: string | undefined): string => {
  const { translations } = useTranslation();

  return content
    ? content
        .split(' ')
        .map((word) => translations[word] ?? word)
        .join(' ')
    : '';
};
